
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  --link-font-family:var(--ff-body);
  --link-font-weight:var(--fw-normal);
  --link-font-size:var(--fs-body-lg);
  --link-line-height:var(--lh-percentage-body);

  --link-color-default:var(--brand-primary-dark-blue);
  --link-color-hover:var(--brand-primary-dark-blue);
  --link-color-disabled:var(--brand-gray-600);

  --link-background-color-default:transparent;
  --link-background-color-hover:var(--brand-primary-green);
  --link-margin-x:0;
  --link-padding-x:0;
}

a{
  font-family:var(--ff-body);
  font-family:var(--link-font-family, var(--ff-body));
  font-weight:var(--fw-normal);
  font-weight:var(--link-font-weight, var(--fw-normal));
  font-size:var(--fs-body-lg);
  font-size:var(--link-font-size, var(--fs-body-lg));
  line-height:var(--lh-percentage-body);
  line-height:var(--link-line-height, var(--lh-percentage-body));
  color:var(--link-color-default);
  margin:0 var(--link-margin-x);
  padding:0 var(--link-padding-x);
  border-top:2px solid transparent;
  background-color:var(--link-background-color-default);
  border-bottom:2px solid var(--link-color-default);
  text-decoration:none;
  transition:0.3s ease all;
}

a:hover,
  a:focus{
    outline:none;
    color:var(--link-color-hover);
    background-color:var(--link-background-color-hover);
  }

a:focus{
    border-top:1px solid var(--link-color-default);
  }

a:disabled{
    color:var(--link-color-disabled);
  }
`;